/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import {
  Clients, Services, Advantages,
} from 'json/landingPageData';
import Header from 'parts/Header';
import Hero from 'parts/Hero';
import Client from 'parts/Clients';
import Service from 'parts/Service';
import Advantage from 'parts/Advantage';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class LandingPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
      <div className="bg-white">
        <Header />
        <Hero />
        <Service data={Services} />
        <Advantage data={Advantages} />
        <Client data={Clients} />
        <Discuss />
        <Footer />
        </div>
      </>
    );
  }
}
